export default __webpack_public_path__ + "static/media/training-illustration.70eaa1da.png";